<div class="footer-div" wmAnimate="jackInTheBox" speed="normal">
  <p class="footer-text">	&copy; 2025, Built with ❤️ by Dheerendra Sharma</p>
</div>
